import { proxy } from 'valtio'

interface ChannelListModalStateType {
  opened: boolean;
}
export const ChannelListModalState = proxy<ChannelListModalStateType>({
  opened: false
})

export const closeChannelListModal = () => {
  ChannelListModalState.opened = false
}

export const openChannelListModal = () => {
  ChannelListModalState.opened = true
}

